<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="header-box text-center pt-4 pl-4 pr-4">
          <a href="https://www.michigan.gov/ok2say" target="_blank">
            <img src="images/ok2say-logo@2x.png" class="logo-image" alt="OK2SAY Logo" />
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h1
          class="mt-2 text-center pl-4 pr-4"
        >A confidential way to report threats to student safety and school personnel.</h1>
      </div>
    </div>
    <div class="row pb-4">
      <div class="col-12">
        <form>
          <school-information-tab
            ref="step1Collapse"
            :show-toggle="step > 1"
            :collapsed="step !== 1"
            :toggle="showInformationTab"
            :continue="saveSchoolAndContinue"
          />

          <incident-detail-tab
            ref="step2Collapse"
            :show-toggle="step > 2"
            :collapsed="step !== 2"
            :toggle="showDetailsTab"
            :continue="saveIncidentAndContinue"
          />

          <my-information-tab
            ref="step3Collapse"
            :show-toggle="step > 3"
            :collapsed="step !== 3"
            :toggle="showMyInformationTab"
            :continue="saveMyInfoAndContinue"
          />

          <submit-information-tab
            ref="step4Collapse"
            :show-toggle="step > 4"
            :collapsed="step !== 4"
            :toggle="showMyInformationTab"
            :submit="submit"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SchoolInformationTab from "./Tabs/SchoolInformation/SchoolInformation";
import IncidentDetailTab from "./Tabs/IncidentDetail/IncidentDetail";
import MyInformationTab from "./Tabs/MyInformation";
import SubmitInformationTab from "./Tabs/SubmitInformation";

const DEFAULT_FORM_ERROR = 'We are unable to save the information at this time. Please try again later.';

export default {
  name: "TipForm",
  components: {
    SchoolInformationTab,
    IncidentDetailTab,
    MyInformationTab,
    SubmitInformationTab
  },

  data() {
    return {
      step: 1,
      schoolInfo: null,
      incidentInfo: null
    };
  },
  methods: {
    saveSchoolAndContinue(data) {
      this.schoolInfo = data;
      this.showDetailsTab();
    },

    saveIncidentAndContinue(data) {
      this.incidentInfo = data;
      this.showMyInformationTab();
    },

    saveMyInfoAndContinue(data) {
      this.myInfo = data;
      this.showSubmitTab();
    },

    async submit() {
      /*
        TODO; set this for prod
        PROD URL: https://ok2say.state.mi.us/mobile/Service/SubmitTip

        POST https://ok2say.state.mi.us/mobile/Service/SubmitTip
        {
          tipSubmitterFirstName: service.profile.firstName,       // firstName
          tipSubmitterLastName: service.profile.lastName,         // lastName
          tipSubmitterPhone: service.profile.phoneNumber,         // phone number
          tipSubmitterEmail: tip.user.email,
          tipSource: service.data.tipSource,                      // ? W === 'web'?
          schoolName: service.data.schoolName,                    // school name
          schoolAddress: service.data.schoolAddress,              // school address
          schoolCity: service.data.schoolCity,                    // school city
          schoolState: service.data.schoolState,                  // school state (MI)
          schoolZip: service.data.schoolZip,                      // school zip
          incidentType: service.data.incidentType,                // incident value type from array up there
          incidentDetails: service.data.incidentDetails,          // incident details text entered by user
          tipIpAddress: service.data.tipIpAddress,                // IP address of submission
          tipSubmitDate: service.data.tipSubmitDate,              // submit date
          GPSLocation: service.data.GPSLocation,                  // GPS location
          tipFile: service.data.tipFile,                          // 64-bit encoded string goes here
          tipFileExt: service.data.tipFileExt                     // png
        };

        returns:
        {
          SubmitTipResult: 12   // Reference number. If there is an error, the SubmitTipResult will be a string containing the error message.
        }
      */

      let location = '';
      if (this.position) {
        const { latitude, longitude } = this.position;
        location = latitude && longitude ? `${latitude},${longitude}` : '';
      }
  
      // Adjust phone number to look like `111-111-1111` instead of `(111) 111-1111`
      let phoneNumber = '';
      if (this.myInfo.phoneNumber) {
        phoneNumber = this.myInfo.phoneNumber.replace(/\D/g, '');
        if (phoneNumber.length === 10) {
          phoneNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
        }
      }

      // Data to send to server
      const data = {
        tipSubmitterFirstName: this.myInfo.firstName,
        tipSubmitterLastName: this.myInfo.lastName,
        tipSubmitterPhone: phoneNumber,
        tipSubmitterEmail: this.myInfo.email,
        tipSource: 'W',
        schoolName: this.schoolInfo.isSchoolRelated ? this.schoolInfo.name : '',
        schoolAddress: this.schoolInfo.isSchoolRelated && this.schoolInfo.address ? this.schoolInfo.address: '',
        schoolCity: this.schoolInfo.isSchoolRelated ? this.schoolInfo.city: '',
        schoolState: this.schoolInfo.isSchoolRelated ? this.schoolInfo.state: '',
        schoolZip: this.schoolInfo.isSchoolRelated && this.schoolInfo.zipCode ? this.schoolInfo.zipCode: '',
        incidentType: this.incidentInfo.type,
        incidentDetails: this.incidentInfo.details,
        tipIpAddress: "",
        tipSubmitDate: (new Date()).toISOString(),
        GPSLocation: location,
        tipFile: this.incidentInfo.imageData,
        tipFileExt: this.incidentInfo.imageExt,
      };

      try {
        const response = await axios.post(process.env.VUE_APP_POST_TIP_URL, data, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        });

        return response.data;
      } catch (error) {
        return {
          SubmitTipResult: DEFAULT_FORM_ERROR
        }
      }
    },

    showInformationTab() {
      this.showStep(1);
    },

    showDetailsTab() {
      this.showStep(2);
      if (navigator.geolocation) {
        navigator.geolocation.watchPosition(data => {
          if (data.coords) {
            this.position = data.coords;
          }
        });
      }
    },

    showMyInformationTab() {
      this.showStep(3);
    },

    showSubmitTab() {
      this.showStep(4);
    },

    // Opens step and closes all others
    showStep(step) {
      this.step = step;
      for (let i = 1; i <= 4; i++) {
        const stepCollapse = this.$refs[`step${i}Collapse`];
        if (stepCollapse) {
          if (step === i) {
            stepCollapse.show();
          } else {
            stepCollapse.hide();
          }
        }
      }
    },

    chooseSituation(event) {
      this.situation = event.target.value;
    },

    onFileUpload(/* event */) {
      let files = [];
      for (let i = 0; i < this.$refs.fileInput.files.length; i++) {
        files.push(window.URL.createObjectURL(this.$refs.fileInput.files[i]));
      }
      this.files = files;
    }
  },

  updated() {
    if (this.updateFocusElement) {
      this.$refs[this.updateFocusElement] &&
        this.$refs[this.updateFocusElement].focus();
      this.updateFocusElement = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.selected-school-box {
  display: flex;
  flex-direction: "row";
}

.selected-school-content {
  flex: 1;
}

.header-box {
  margin: 0 auto;
}

.logo-image {
  width: 100%;
  max-width: 16rem;
  height: auto;
}

h1 {
  font-size: 1.2rem;
  font-weight: normal;
  letter-spacing: inherit;
}
@media screen and (max-width: 600px) {
  h1 {
    font-size: 1rem;
  }
}

.bold {
  font-weight: bold;
}

.box {
  background-color: white;
}

.max-width-30 {
  max-width: 30rem;
}

.max-width-40 {
  max-width: 40rem;
}

.form-content {
  padding: 2rem;
  padding-top: 0;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 1rem;
}

h3 {
  padding: 1rem;
  margin: 0;
  color: rgb(52, 118, 163);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media screen and (max-width: 600px) {
  h3 {
    font-size: 1.2rem;
  }
}

.special-label {
  text-align: center;
  padding: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgb(236, 236, 236);
}

textarea {
  height: 8rem;
}

textarea,
select,
input {
  font-size: 0.875rem;
}

textarea::placeholder {
  color: #aaa;
}

.message {
  margin: 0 auto;
}

.align-center {
  margin: 0 auto;
}

.border-top {
  border-top: 1px solid rgb(29, 25, 25);
}

.border-top-light {
  border-top: 1px solid rgb(236, 236, 236);
}

.text-bold {
  font-weight: bold;
}

.enter-school-information-manually {
  margin-bottom: 1rem;
}

.label-optional {
  font-size: 0.6rem;
  color: rgb(110, 110, 110);
  margin-left: 0.25rem;
}

.radio-container {
  padding: 0.5rem 1rem;
}

.radio-container.is-invalid {
  border-radius: 0.25rem;
  border: 1px solid #b80000;
}
</style>

<style>
</style>